export const EGOV_ACCOUNT_MESSAGES: {[key: string]: string} = {
  logged_in: 'e-Govアカウントを連携しました',
  already_exists: 'e-Govアカウントはすでに連携済みです',
  egov_api_error: 'e-Govアカウントの連携に失敗しました',
  failed_to_create_account: 'e-Govアカウントの登録に失敗しました',
  invalid_argument: '連携中のe-Govアカウントにログインしてください',
} as const
